import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_SCALES } from "../../../routes";
import { createScale } from "../actions/scalesActions";
import FormPage from "../../common/components/layout/FormPage";
import CreateScaleForm from "../components/CreateScaleForm";

class CreateScale extends FormPage {
  static propTypes = {
    scale: shape().isRequired,
    match: shape().isRequired,
    createScale: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * @param {object} scale
   */
  onSubmit(scale) {
    const { createScale, match } = this.props;
    const paramsScale = {
      clientUuid: match.params.uuid,
      ...scale,
    };

    createScale(paramsScale);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.scales.add.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_SCALES;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { scale } = this.props;

    return (
      <CreateScaleForm
        loading={scale.saving}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  scale: state.scale,
});

const mapDispatchToProps = (dispatch) => ({
  createScale: (params) => dispatch(createScale(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateScale);
